import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-lg px-4 py-20 text-center">
      <h1 className="font-display text-3xl text-dome-forest">Page not found</h1>
      <p className="mt-2 text-sm text-[var(--muted)]">
        That route is not part of the Dome Events desk.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-lg bg-dome-forest px-4 py-2 text-dome-sand"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
